import { computed, get } from '@ember/object';

export default function equalsAny(dependentKey, possibleValues) {
  return computed(dependentKey, function () {
    return possibleValues.indexOf(get(this, dependentKey)) !== -1;
  });
}
